module.exports = __webpack_public_path__ + "static/media/Bianca_ Sissing.39481f47.jpg";